<script>
export default {
    name: 'ServicePlanFeatureRecord',
};
</script>

<script setup>
import { computed, toRef } from 'vue';
import i18n from '@/plugins/i18n.ts';
import formatNumber from '@/utils/format-number.ts';
import { FIELD, RECORD_SCOPE } from '@/components/payments/components/service-plan/components/features/constants';
import useFeature from '@/components/payments/components/service-plan/components/features/composables/use-feature';
import ServicePlanFeatureElementsValue from '@/components/payments/components/service-plan/components/features/components/elements/value';

const props = defineProps({
    feature: {
        type: Object,
        required: true,
    },
});

const { limit: value, limitUsed: used, scope } = useFeature(toRef(props, 'feature'));

const formatted = computed(() => {
    if (!value.value) return i18n.t('payment.servicePlan.feature.record.all');

    const count = formatNumber(value.value, true);

    if (used.value === null || used.value === undefined) {
        return {
            [RECORD_SCOPE.INSTANCE]: i18n.t('payment.servicePlan.feature.record.instance', { count }),
            [RECORD_SCOPE.INSTANCE_ENTITY]: i18n.t('payment.servicePlan.feature.record.instanceEntity', { count }),
        }[scope.value];
    }

    const available = Math.max(value.value - used.value, 0);

    return {
        [RECORD_SCOPE.INSTANCE]: i18n.tc('payment.servicePlan.feature.record.instanceAvailable', available, {
            available: formatNumber(available, true),
            count,
        }),
        [RECORD_SCOPE.INSTANCE_ENTITY]: i18n.tc('payment.servicePlan.feature.record.instanceEntityAvailable', available, {
            available: formatNumber(available, true),
            count,
        }),
    }[scope.value];
});

</script>

<template>
    <service-plan-feature-elements-value
        :name="feature[FIELD.NAME]"
        :value="formatted"
    />
</template>
